export enum Paths {
  AUDIT = "/audit",
  DESIGN_SYSTEM = "/design-system",
}

export enum AuditPaths {
  EMBED = `${Paths.AUDIT}/embed/`,
}
